import { previewDisplayTextTypeRampFull, previewDisplayTextTextFlow, previewLinesContainer, previewLinesContainerTextFlow, previewLinesDisplayText, } from "owa-mail-listitem-styles/lib/scss/MailListItem.scss";
import classnames from "owa-classnames";
import { getDensityModeCssClass } from "owa-fabric-theme";
import { tokens } from "@fluentui/react-components";
import { observer } from "owa-mobx-react";
import { highlightTermsInHtmlElement } from "owa-highlight";
import { useIsTypeRampUpdatesEnabled } from "owa-mail-list-item-shared/lib/utils/useIsTypeRampUpdatesEnabled";
import { useMessageListTextStyle } from "owa-mail-listitem-styles/lib/utils/useMessageListTextStyle";
import type { Accuracy } from "owa-mark/lib/utils/markElements";
import React from "react";
import CopilotPrioritizeOnboardedCallout from "./CopilotPrioritizeOnboardedCallout";
import { getStore as getMailListStore } from "owa-mail-list-store";
import type { MailboxInfo } from "owa-client-types";
import { isPrioritizeOnDeliveryOn } from "owa-copilot-settings-utils";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";

export interface MailListItemPreviewDisplayProps {
    highlightTerms: string[];
    previewDisplay: string;
    highlightAccuracy?: Accuracy;
    rowId: string;
    mailboxInfo: MailboxInfo;
    copilotPrioritizeOnDeliveryOn?: boolean;
    isSelected: boolean;
    cfTextStyle?: React.CSSProperties;
    numMessagePreviewLines: number;
    useTextFlowLayout?: boolean;
}

const defaultExport: React.FunctionComponent<MailListItemPreviewDisplayProps> = observer(function MailListItemPreviewDisplay(props: MailListItemPreviewDisplayProps) {
    const { highlightTerms, previewDisplay, highlightAccuracy, rowId, cfTextStyle, numMessagePreviewLines, useTextFlowLayout, } = props;
    const isTypeRampUpdatesEnabled = useIsTypeRampUpdatesEnabled();
    const isWin32Style = isWin32StylingEnabled();
    const rowRef = React.useRef<HTMLDivElement>(null);
    const targetRowId = getMailListStore().copilotPrioritizeOnboardedCalloutTarget;
    
    const previewRef = React.useRef<HTMLSpanElement>(null);
    React.useEffect(() => {
        highlightTermsInHtmlElement(previewRef.current, highlightTerms, false /* separateWordSearch */, highlightAccuracy /* highlightAccuracy */);
    }, [highlightTerms, highlightAccuracy, previewDisplay, numMessagePreviewLines]);
    
    const textStyle = React.useMemo(() => cfTextStyle
        ? {
            color: `var(--cfHoverTextColorOverride, ${tokens.colorNeutralForeground2})`,
        }
        : {}, [cfTextStyle]);
    
    const containerClassName = classnames(previewLinesContainer, useTextFlowLayout && previewLinesContainerTextFlow);
    const spanClassName = classnames(previewLinesDisplayText, useTextFlowLayout && previewDisplayTextTextFlow, useMessageListTextStyle("Major", undefined /* isFirstLine */, undefined /* isSingleLineView */, isWin32Style), isTypeRampUpdatesEnabled &&
        getDensityModeCssClass(previewDisplayTextTypeRampFull, undefined, undefined));
    
    return (<div className={containerClassName} ref={rowRef}>
                <span key={numMessagePreviewLines} className={spanClassName} ref={previewRef} style={textStyle}>
                    {previewDisplay}
                </span>
                {targetRowId === rowId &&
            (props.copilotPrioritizeOnDeliveryOn ??
                isPrioritizeOnDeliveryOn(props.mailboxInfo)) && (<CopilotPrioritizeOnboardedCallout target={rowRef} id="CopilotPrioritizeOnboarded"/>)}
            </div>);
}, "MailListItemPreviewDisplay");
export default defaultExport;
